

export const useHeaderCurrentIndex = defineStore('headerCurrentIndex', {
    state: () => ({
        currentIndex: 0
    }),
    actions: {
        updateCurrentIndex(index: number) {
            this.currentIndex = index
        }
    },
    getters: {
        getCurrentIndex(): number {
            return this.currentIndex
        }
    }
})